import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiTopSalesConfig, ApiTopSalesRecommendationsResponse } from './api-top-sales.model';

import { environment } from '@env/environment';

@Injectable()
export class ApiTopSalesService {
    constructor(private readonly http: HttpClient) {}

    private readonly config: ApiTopSalesConfig = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${environment.endpointRecommendationsTinybirdToken}`,
        },
        params: {
            tenant_id: 'md',
            max_products: 10,
        },
    };

    public getEpRecommendedProducts$(
        storeId: string,
        section: number,
        campaign: string,
        hashedMail: string,
    ): Observable<ApiTopSalesRecommendationsResponse> {
        const url: string = environment.endpointEpRecommendationsUrl;
        this.config.params = {
            ...this.config.params,
            store_id: storeId,
            cod_section: section,
            campaign,
            email_sha256: hashedMail || 'generic_recommendation',
            max_products: 200,
        };

        return this.http.get<ApiTopSalesRecommendationsResponse>(url, this.config);
    }
}
